import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SyncService {
  baseUrl = environment.apiUrl + 'SyncroHistory/';
  baseUrl2 = environment.apiUrl + 'SyncroDetail/';
  baseUrl3 = environment.apiUrl + 'Queries/';

  constructor(private http: HttpClient) {}


  getLastSync(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `last-syncro`, { observe: 'response' });
  }

  getAllSyncs(page: number, filters, pageSize): Observable<HttpResponse<any>> {
    return this.http.post<any>(this.baseUrl2 + `filter?page=${page}&pageSize=${pageSize}`, filters);
  }

  getSections(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl2 + `sections`, { observe: 'response' });
  }

  getUsers(): Observable<HttpResponse<any>> {
    return this.http.get<any>(this.baseUrl + `executing-users`, { observe: 'response' });
  }

  syncUp(): Observable<HttpResponse<any>> {
    return this.http.post<any>(this.baseUrl3 + `sync`, null);
  }

  download(filters): Observable<HttpResponse<Blob>> {
    return this.http.post<Blob>(this.baseUrl2 + `download`, filters, { responseType: 'blob' as 'json', observe: 'response' });
  }

  getJsonById(id): Observable<any> {
    return this.http.get(this.baseUrl2 + `get-json-by-id?detailId=${id}`, { responseType: 'json', observe: 'response' });
  }

  canSync(): Observable<any> {
    return this.http.get<any>(this.baseUrl + `last-sync-older-than-two-hours`, { observe: 'response' });
  }
}
